export default __webpack_public_path__ + "static/media/icon_paypal_express.d642c1c4.png";